import React from 'react'
import { withRouter } from 'react-router'
import getUrlParameters from '../../getUrlParameters'
import getStrings from '../../getStrings'
import ParentPortalDashboardDeleteAccount from './deleteaccount'
import getErrorMessage from '../../getErrorMessage'
import AppContext from 'core/appContext'
import styles from './manageaccount.module.scss'
import {getSubscriptionStatus, getUserData, createStripePurchaseSession, createStripeManageSession} from "../../Uluweb"
import { sendAccountRecoveryEmail } from "../../Playfab"


class ParentPortalManageAccount extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            deleteAccountUI: false,
            canSubscribe: false,
            userData: null
        }
    }

    componentDidMount() {
        this.verifyCanSubscribeOrRedirect()
    }

    verifyCanSubscribeOrRedirect = () => {
        if (!localStorage.getItem('session')){
            this.handleLogOut()
            return
        }
            
        const session = JSON.parse(localStorage.getItem('session'))
        if (!session.hasOwnProperty('token')) {
            this.handleLogOut()
            return
        }

        const promises = []
        let isSubscribed
        let userData

        promises.push(getSubscriptionStatus(session.token).then(result => {
            if (!result.success && result.error === "TOKEN_EXPIRED"){
                this.handleLogOut()
                return
            }

            if (result.success)
                isSubscribed = result.isSubscribed
            else
                console.error('getSubscriptionStatus ', result)
        }))
        
        promises.push(getUserData(session.token).then(result => {
            if (!result.success && result.error === "TOKEN_EXPIRED"){
                this.handleLogOut()
                return
            }

            if (result.success)
                userData = result
            else
                console.error('getUserData ', result)
        }))

        Promise.allSettled(promises).then(_ => {
            if(isSubscribed !== undefined && userData !== undefined) {
                this.setState({
                    userData: userData,
                    canSubscribe: !isSubscribed
                })
            }
        })
    }

    handleLogOut = () => {
        localStorage.removeItem('session')
        this.props.history.push(`/?${getUrlParameters()}`)
        setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 0)
    }

    handlePasswordRecovery = async () => {
        const session = JSON.parse(localStorage.getItem('session'))

        const playfabAPIResponse = await this.trySendAccountRecoveryEmail(session.email)
        if (playfabAPIResponse.status === 200) {
            const strings = getStrings()
            console.log('manageaccount.handlePasswordRecovery: ', playfabAPIResponse)
            alert(strings.PARENT_PORTAL_ALERT_RESET_PASSWORD_SUCCESS)
        }
    }

    handleDeleteAccount = async () => this.setState({deleteAccountUI: true})

    trySendAccountRecoveryEmail = async (email) => {
        try {
            return await sendAccountRecoveryEmail(email)
        } catch (err) {
            this.blockUI(false)
            this.displayError(err.response.data.error)
        }
    }

    blockUI = (shouldBlock) => this.context.setBlockUI(shouldBlock)

    displayError = (errorCode) => {
        const strings = getStrings()
        if (!errorCode || Object.keys(errorCode).length === 0) {
            console.error('manageaccount.displayError: generic: ', errorCode)
            return alert(strings.PARENT_PORTAL_MANAGE_ACCOUNT_ERROR_GENERIC_ERROR)
        }

        console.error(`manageaccount.displayError: ${errorCode}`)
        alert(getErrorMessage('PARENT_PORTAL_MANAGE_ACCOUNT_ERROR_', errorCode, strings))
    }

    deleteAccountDisplay(shouldDisplay) {
        this.setState({deleteAccountUI: shouldDisplay})
    }

    getStripeCustomerID = () => {
        if (this.state.userData) {
            const integration = this.state.userData.integrations.find(integration => integration.service === 'Stripe')
            if (integration)
                return integration.serviceKey
        }

        return ''
    }

    render() {
        const sessionString = localStorage.getItem('session')
        if (!sessionString)
            return <></>

        const session = JSON.parse(sessionString)
        const email = session.email
        const stripeCustomerID = this.getStripeCustomerID()

        const strings = getStrings()

        return (
            <>
                <ParentPortalDashboardDeleteAccount 
                    shown={this.state.deleteAccountUI}
                    deleteAccountDisplay={this.deleteAccountDisplay.bind(this)}
                    userData={this.state.userData} />
                <div className='form-outer form-container'>
                    <div className='form-box'>
                        <h2 className='text-center'>{strings.PARENT_PORTAL_MANAGE_ACCOUNT_H2}</h2>

                        <p className='text-center'>{strings.PARENT_PORTAL_MANAGE_ACCOUNT_EMAIL_LABEL}: {email}</p>

                        <div className='flex-row justify-center gap-2'>
                            {
                                stripeCustomerID &&
                                    <div>
                                        <button
                                            className='button large contained primary'
                                            onClick={async () => {
                                                this.blockUI(true)
                                                const stripeResponse = await createStripeManageSession(stripeCustomerID)
                                                window.location.replace(stripeResponse.data.session.url)
                                            }}
                                        >
                                            {strings.PARENT_PORTAL_MANAGE_ACCOUNT_MANAGE_SUBSCRIPTION_BUTTON}
                                        </button>
                                    </div>
                            }
                            {
                                !stripeCustomerID && this.state.canSubscribe &&
                                    <div>
                                        <button 
                                            className='button large contained primary'
                                            onClick={async () => {
                                                this.blockUI(true)
                                                const stripeResponse = await createStripePurchaseSession(this.state.userData.id)
                                                
                                                if (stripeResponse.data.success)
                                                    window.location.replace(stripeResponse.data.session.url)
                                                else {
                                                    this.blockUI(false)
                                                    this.displayError(stripeResponse.data.error)
                                                }
                                            }}
                                        >
                                            {strings.PARENT_PORTAL_MANAGE_ACCOUNT_SUBSCRIBE_BUTTON}
                                        </button>
                                    </div>
                                        
                            }
                        </div>

                        <div className='flex-row justify-center gap-2 margin-top-2 margin-bottom-2'>
                            <button 
                                className='button bordered blue'
                                onClick={this.handlePasswordRecovery.bind(this)}
                            >
                                {strings.PARENT_PORTAL_MANAGE_ACCOUNT_RESET_PASSWORD_BUTTON}
                            </button>
                            <button className='button bordered blue' onClick={this.handleLogOut.bind(this)}>
                                {strings.PARENT_PORTAL_MANAGE_ACCOUNT_LOG_OUT_BUTTON}
                            </button>
                            <button 
                                className='button contained warn'
                                onClick={this.handleDeleteAccount.bind(this)}
                            >
                                {strings.PARENT_PORTAL_MANAGE_ACCOUNT_DELETE_ACCOUNT_BUTTON}
                            </button>
                        </div>

                        <img src={`${process.env.PUBLIC_URL}/images/parentportal/IpadMockups.png`} alt='iPad mockups' className={styles['ipad-images']} />
                    </div>
                </div>
            </>
        )
    }
}

ParentPortalManageAccount.contextType = AppContext

export default withRouter(ParentPortalManageAccount)